<template>
  <v-row>
    <v-col cols="12" md='4' v-if="!$isMobile">
      <v-card class="elevation-0 rounded-lg">
        <v-card-title class="size-18">
          <v-avatar color="purple lighten-5" rounded="lg" size="26" class="mt-n1">
            <v-icon dark small color="purple">mdi-equalizer</v-icon>
          </v-avatar>&nbsp;&nbsp;个人绩效
          <v-spacer></v-spacer>
          <v-tooltip top v-if="rewardInfos.length>0 && $moment(rewardInfos[0].startTime * 1000).format('YYYY-MM') === $moment(new Date().getTime()).format('YYYY-MM')">
            <template v-slot:activator="{ on, attrs }">
              <span class="red--text" v-bind="attrs"  v-on="on" >
                <svg class="icon" style="width:30px;height:30px" aria-hidden="true">
                  <use xlink:href="#icon-caiyouduo_gendanxiangqing-yinglijiangli-copy-copy"></use>
                </svg>
              </span>
            </template>
            <span>
              {{$moment(rewardInfos[0].startTime * 1000).format('MM-DD')}}号~{{$moment(rewardInfos[0].endTime * 1000).format('MM-DD')}}号
              <div class="my-1" v-for="(item, i) in rewardInfos[0].contentList" :key="i">
                <span class="mr-2">第{{item.key}}名: </span>
                <span>¥{{item.value}}</span>
              </div>
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-card v-for="(item, idx) in selfRankings.filter((i) => i.num <= 5)" :key="idx" class="mb-2 py-3"
            outlined
          >
            <v-row>
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="40">
                  <img :src="item.avatar" >
                </v-avatar>
              </v-col>
              <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold py-0">
                <div>
                  <v-chip v-if="idx < 3 && rewardInfos.length>0 && $moment(rewardInfos[0].endTime * 1000).valueOf() >= $moment().startOf('day').valueOf()" dark x-small class="px-1" color="red">
                    {{idx === 0 ? '一等奖' : idx === 1 ? '二等奖' : '三等奖'}}
                  </v-chip>
                  {{item.name}}
                </div>
                <div>签单量：{{item.signNumber}}</div>
                <div>绩效额：{{item.profitPrice}}</div>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="40" :color="item.num === 1 ? 'amber' : item.num === 2 ? 'grey' : item.num === 3 ? 'brown' : 'pink'">
                  <v-icon color="white">mdi-crown-outline</v-icon>
                </v-avatar>
              </v-col>
            </v-row>
          </v-card>
          <div v-if="selfRankings.length < 5">
            <v-card v-for="(item) in (5 - selfRankings.length)" :key="`self-${item}`" class="mb-2 py-3"
              outlined
            >
              <v-row>
                <v-col cols="12" md="3" class="text-center">
                  <v-avatar size="40" color="pink">
                    <v-icon color="white">mdi-help</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold mt-2">
                  虚位以待...
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-avatar size="40" color="pink">
                    <v-icon color="white">mdi-dots-horizontal</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 mr-c-1">
          <v-spacer></v-spacer>
          <v-btn @click="selfShow = !selfShow" text small color="grey">
            <v-icon>{{ selfShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            {{selfShow ? '折叠' : '更多'}}
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="selfShow">
            <v-card-text>
              <v-card v-for="(item, idx) in selfRankings.filter((i) => i.num > 5)" :key="idx" class="mb-2 py-3" elevation="0" outlined>
                <v-row>
                  <v-col cols="12" md="3" class="text-center">
                    <v-avatar size="40">
                      <img :src="item.avatar" >
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold  py-0">
                    <div>{{item.name}}</div>
                    <div>签单量：{{item.signNumber}}</div>
                    <div>绩效额：{{item.profitPrice}}</div>
                  </v-col>
                  <v-col cols="12" md="3" class="text-center">
                    <v-avatar size="40" color="pink">
                      <v-icon color="white">mdi-crown-outline</v-icon>
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </v-col>
    <v-col cols="12" md='4' v-else>
      <v-card class="elevation-0 rounded-lg">
        <v-card-title>个人绩效</v-card-title>
        <v-card-text class="px-1">
          <v-divider></v-divider>
          <v-data-table
              :headers="selfRankingHeaders"
              :items="selfRankings"
              class="elevation-0"
              :items-per-page='5'
              mobile-breakpoint='300'
            >
            <template v-slot:body="{ items, headers }">
              <tbody>
                <tr v-for="(item, idx) in items" :key="idx">
                  <td
                    :style="$isMobile && i === 0 ? 'width:50px' : ''"
                    v-for="(h, i) in headers"
                    :key="i"
                    class="text-center fixed-left pa-0" >
                    <v-badge bordered :content="item['num']" overlap v-if="h.value === 'index'" :color="item['num'] === 1 ? 'red' : item['num'] === 2 ? 'orange' : item['num'] === 3 ? 'amber' : 'grey'">
                      <v-avatar size="35">
                        <img :src="item.avatar" >
                      </v-avatar>
                    </v-badge>
                    <span v-else :class="$isMobile ? 'size-13 pa-0' : ''">{{item[h.value]}}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>


   <v-col cols="12" md='4' v-if="!$isMobile">
      <v-card class="elevation-0 rounded-lg">
        <v-card-title class="size-18">
          <v-avatar color="teal lighten-5" rounded="lg" size="26" class="mt-n1">
            <v-icon dark small color="teal">mdi-google-analytics</v-icon>
          </v-avatar>&nbsp;&nbsp;部门绩效
          <v-spacer></v-spacer>
          <v-tooltip top v-if='rewardInfos.length>1'>
            <template v-slot:activator="{ on, attrs }">
              <span class="red--text" v-bind="attrs"  v-on="on" >
                <svg class="icon" style="width:30px;height:30px" aria-hidden="true">
                  <use xlink:href="#icon-caiyouduo_gendanxiangqing-yinglijiangli-copy-copy"></use>
                </svg>
              </span>
            </template>
            <span>
              {{$moment(rewardInfos[1].startTime * 1000).format('MM-DD')}}号~{{$moment(rewardInfos[1].endTime * 1000).format('MM-DD')}}号
              <div class="my-1" v-for="(item, i) in rewardInfos[1].contentList" :key="i">
                <span class="mr-2">第{{item.key}}名: </span>
                <span>¥{{item.value}}</span>
              </div>
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-card v-for="(item, idx) in deptRankings.filter((i) => i.num <= 5)" :key="idx" class="mb-2 py-3"
            outlined
          >
            <v-row>
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="40" :color="item.num === 1 ? 'amber' : item.num === 2 ? 'grey' : item.num === 3 ? 'brown' : 'pink'">
                  <span class="white--text font-weight-bold">{{item.num}}</span>
                </v-avatar>
              </v-col>
              <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold py-0">
                <div>
                  <v-chip v-if="idx < 3 && rewardInfos.length>0 && $moment(rewardInfos[0].endTime * 1000).valueOf() >= $moment().startOf('day').valueOf()" dark x-small class="px-1" color="red">
                    {{idx === 0 ? '一等奖' : idx === 1 ? '二等奖' : '三等奖'}}
                  </v-chip>
                  {{item.name}} &nbsp;({{item.signNumber}}单)
                </div>
                <div>回款额：{{item.returnPrice}}</div>
                <div>绩效额：{{item.profitPrice}}</div>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="40" :color="item.num === 1 ? 'amber' : item.num === 2 ? 'grey' : item.num === 3 ? 'brown' : 'pink'">
                  <v-icon color="white">mdi-crown-outline</v-icon>
                </v-avatar>
              </v-col>
            </v-row>
          </v-card>
          <div v-if="deptRankings.length < 5">
            <v-card  v-for="(item) in (5 - deptRankings.length)" :key="`dept-${item}`" class="mb-2 py-3"
              outlined
            >
              <v-row>
                <v-col cols="12" md="3" class="text-center">
                  <v-avatar size="40" color="pink">
                    <v-icon color="white">mdi-help</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold mt-2">
                  虚位以待...
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-avatar size="40" color="pink">
                    <v-icon color="white">mdi-dots-horizontal</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 mr-c-1">
          <v-spacer></v-spacer>
          <v-btn @click="deptShow = !deptShow" text small color="grey" :disabled="deptRankings.length <= 5">
            <v-icon>{{ deptShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            {{selfShow ? '折叠' : '更多'}}
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="deptShow">
            <v-card-text>
              <v-card v-for="(item, idx) in deptRankings.filter((i) => i.num > 5)" :key="idx" class="mb-2 py-3" elevation="0" outlined>
                <v-row>
                  <v-col cols="12" md="3" class="text-center">
                    <v-avatar size="40" color="pink">
                      <span class="white--text font-weight-bold">{{item.num}}</span>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold  py-0">
                    <div>{{item.name}} &nbsp;({{item.signNumber}}单)</div>
                    <div>回款额：{{item.returnPrice}}</div>
                    <div>绩效额：{{item.profitPrice}}</div>
                  </v-col>
                  <v-col cols="12" md="3" class="text-center">
                    <v-avatar size="40" color="pink">
                      <v-icon color="white">mdi-crown-outline</v-icon>
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </v-col>
    <v-col cols="12" md='4' v-else>
      <v-card class="elevation-0 rounded-lg">
        <v-card-title>
          部门绩效
        </v-card-title>
        <v-card-text class="px-1">
          <v-divider></v-divider>
          <v-data-table
              :headers="deptRankingHeaders"
              :items="deptRankings"
              class="elevation-0"
              :items-per-page='5'
              mobile-breakpoint='300'
            >
            <template v-slot:body="{ items, headers }">
              <tbody>
                <tr v-for="(item, idx) in items" :key="idx">
                  <td
                    :style="$isMobile && i === 0 ? 'width:60px' : ''"
                    v-for="(h, i) in headers"
                    :key="i"
                    class="text-center fixed-left pa-0" >
                    <v-avatar v-if="h.value === 'index'" :color="item['num'] === 1 ? 'red' : item['num'] === 2 ? 'orange' : item['num'] === 3 ? 'amber' : 'grey'" :size="$isMobile ? 27 : 36">
                      <span :class="$isMobile ? 'white--text size-13' : 'white--text text-h5'">{{item['num']}}</span>
                    </v-avatar>
                    <span v-else :class="$isMobile ? 'size-13  pa-0' : ''">{{item[h.value]}}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>


    <v-col cols="12" md='4' v-if="!$isMobile">
      <v-card class="elevation-0 rounded-lg">
        <v-card-title class="size-18">
          <v-avatar color="cyan lighten-5" rounded="lg" size="26" class="mt-n1">
            <v-icon dark small color="cyan">mdi-podium-silver</v-icon>
          </v-avatar>&nbsp;&nbsp;个人收款
          <v-spacer></v-spacer>
          <v-tooltip left v-if='rewardInfos.length>2'>
            <template v-slot:activator="{ on, attrs }">
              <span class="red--text" v-bind="attrs"  v-on="on" >
                <svg class="icon" style="width:30px;height:30px" aria-hidden="true">
                  <use xlink:href="#icon-caiyouduo_gendanxiangqing-yinglijiangli-copy-copy"></use>
                </svg>
              </span>
            </template>
            <span>
              {{$moment(rewardInfos[2].startTime * 1000).format('MM-DD')}}号~{{$moment(rewardInfos[2].endTime * 1000).format('MM-DD')}}号
              <div class="my-1" v-for="(item, i) in rewardInfos[2].contentList" :key="i">
                <span class="mr-2">第{{item.key}}名: </span>
                <span>¥{{item.value}}</span>
              </div>
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-card v-for="(item, idx) in selfReturnRankings.filter((i) => i.num <= 5)" :key="idx" class="mb-2 py-3"
            outlined
          >
            <v-row>
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="40">
                  <img :src="item.avatar" >
                </v-avatar>
              </v-col>
              <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold my-c-7 py-1">
                <div>
                  <v-chip v-if="idx < 3 && rewardInfos.length>0 && $moment(rewardInfos[0].endTime * 1000).valueOf() >= $moment().startOf('day').valueOf()" dark x-small class="px-1" color="red">
                    {{idx === 0 ? '一等奖' : idx === 1 ? '二等奖' : '三等奖'}}
                  </v-chip>
                  {{item.name}}
                </div>
                <div>收款额：
                  <span v-if="item.id === $store.state.userInfo.id || $store.state.userInfo.roleIds.indexOf(1) !== -1"> {{item.returnPrice}}</span>
                  <span v-else>******</span>
                </div>
              </v-col>
              <v-col cols="12" md="3" class="text-center">
                <v-avatar size="40" :color="item.num === 1 ? 'amber' : item.num === 2 ? 'grey' : item.num === 3 ? 'brown' : 'pink'">
                  <v-icon color="white">mdi-crown-outline</v-icon>
                </v-avatar>
              </v-col>
            </v-row>
          </v-card>
          <div v-if="selfReturnRankings.length < 5">
            <v-card  v-for="(item) in (5 - selfReturnRankings.length)" :key="`return-${item}`" class="mb-2 py-3"
              outlined
            >
              <v-row>
                <v-col cols="12" md="3" class="text-center">
                  <v-avatar size="40" color="pink">
                    <v-icon color="white">mdi-help</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold  mt-2">
                  虚位以待...
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <v-avatar size="40" color="pink">
                    <v-icon color="white">mdi-dots-horizontal</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 mr-c-1">
          <v-spacer></v-spacer>
          <v-btn @click="selfReturnShow = !selfReturnShow" text small color="grey">
            <v-icon>{{ selfReturnShow ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            {{selfShow ? '折叠' : '更多'}}
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="selfReturnShow">
            <v-card-text>
              <v-card v-for="(item, idx) in selfReturnRankings.filter((i) => i.num > 5)" :key="idx" class="mb-2 py-3" elevation="0" outlined>
                <v-row>
                  <v-col cols="12" md="3" class="text-center">
                    <v-avatar size="40">
                      <img :src="item.avatar" >
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" md="6" class="grey--text text--darken-1 font-weight-bold my-c-7 py-0">
                    <div>{{item.name}}</div>
                    <div>收款额：
                      <span v-if="item.id === $store.state.userInfo.id || $store.state.userInfo.roleIds.indexOf(1) !== -1"> {{item.returnPrice}}</span>
                      <span v-else>******</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" class="text-center">
                    <v-avatar size="40" color="pink">
                      <v-icon color="white">mdi-crown-outline</v-icon>
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </v-col>
    <v-col cols="12" md='4' v-else>
      <v-card class="elevation-0 rounded-lg">
        <v-card-title>
          个人收款
        </v-card-title>
        <v-card-text :class="$isMobile ? 'px-1' : ''">
          <v-divider></v-divider>
          <v-data-table
              :headers="selfReturnRankingHeaders"
              :items="selfReturnRankings"
              class="elevation-0"
              :items-per-page='5'
              mobile-breakpoint='300'
            >
            <template v-slot:body="{ items, headers }">
              <tbody>
                <tr v-for="(item, idx) in items" :key="idx">
                  <td
                    :style="$isMobile && i === 0 ? 'width:60px' : ''"
                    v-for="(h, i) in headers"
                    :key="i"
                    class="text-center pa-0" >
                    <v-badge bordered :content="item['num']" overlap v-if="h.value === 'index'" :color="item['num'] === 1 ? 'red' : item['num'] === 2 ? 'orange' : item['num'] === 3 ? 'amber' : 'grey'">
                      <v-avatar size="35">
                        <img :src="item.avatar" >
                      </v-avatar>
                    </v-badge>
                    <span v-else :class="$isMobile ? 'size-13 pa-0' : ''">{{item[h.value]}}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

  </v-row>
</template>

<script>

  export default {
    name: 'DashboardRanking',
    props: {
      selfRankings: {
        type: Array,
        default: () => ([])
      },
      deptRankings: {
        type: Array,
        default: () => ([])
      },
      selfReturnRankings: {
        type: Array,
        default: () => ([])
      },
      rewardInfos: {
        type: Array,
        default: () => ([])
      }
    },
    components: {
    },
    data() {
      return {
        selfShow: false,
        deptShow: false,
        selfReturnShow: false,
        selfRankingHeaders: [
          {
            text: '排名',
            align: 'center',
            width: 70,
            value: 'index',
            sortable: false,
          },
          {
            text: '姓名',
            align: 'center',
            width: 80,
            value: 'name',
            sortable: true
          },
          {
            text: '绩效额',
            align: 'center',
            width: 90,
            value: 'profitPrice',
            sortable: true
          },
          {
            text: '签单量',
            align: 'center',
            width: 90,
            value: 'signNumber',
            sortable: true
          }
        ],
        deptRankingHeaders: [
          {
            text: '排名',
            align: 'center',
            width: 70,
            value: 'index',
            sortable: false
          },
          {
            text: '姓名',
            align: 'center',
            width: 80,
            value: 'name',
            sortable: true
          },
          {
            text: '绩效额',
            align: 'center',
            width: 100,
            value: 'profitPrice',
            sortable: true
          },
          {
            text: '签单量',
            align: 'center',
            width: 90,
            value: 'signNumber',
            sortable: true
          },
          {
            text: '回款额',
            align: 'center',
            width: 90,
            value: 'returnPrice',
            sortable: true
          }
        ],
        selfReturnRankingHeaders: [
          {
            text: '排名',
            align: 'center',
            width: 70,
            value: 'index',
            sortable: false
          },
          {
            text: '姓名',
            align: 'center',
            width: 80,
            value: 'name',
            sortable: true
          },
          {
            text: '收款额',
            align: 'center',
            width: 100,
            value: 'returnPrice',
            sortable: true
          }
        ]
      }
    }
  }
</script>

<style lang="scss">
.ranking-title{
  float: left;
}
.ranking-chip{
  float: right;
}
</style>
